module.exports = __webpack_public_path__ + "fonts/Farmacia.47e485d.eot";